import { Component, Input } from "@angular/core";
import { UpsellWhy } from "src/app/models/upsellWhy";

@Component({
    selector: "upsell-why",
    templateUrl: "upsell-why.html",
    styleUrls: ["upsell-why.scss"],
    standalone: false
})

export class UpsellWhyComponent {

  @Input() upsellWhyContent: Array<UpsellWhy> = [];
  @Input({ transform: (value: string | null | undefined) => value || 'https://cdn.lonewolfranchpets.com/images/chuck-photo.jpg' }) upsellWhyImage = 'https://cdn.lonewolfranchpets.com/images/chuck-photo.jpg';
  
  constructor() {}
}